import { render, staticRenderFns } from "./BranchGender.vue?vue&type=template&id=4ef18c10&"
import script from "./BranchGender.vue?vue&type=script&lang=js&"
export * from "./BranchGender.vue?vue&type=script&lang=js&"
import style0 from "./BranchGender.vue?vue&type=style&index=0&id=4ef18c10&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports